import { Component, Input, OnChanges } from '@angular/core';

import { CompetitionResultDto } from '@app/core/driver-wig.model';
import { IDriverWigService } from '@app/core/services/interface/IDriverWigService';
import { ServiceFactory } from '@app/core/services/service.factory';

@Component({
  selector: 'app-fleet-competition-results',
  styleUrls: ['./fleet-competition-results.component.css'],
  templateUrl: './fleet-competition-results.component.html',
})
export class FleetCompetitionResultsComponent implements OnChanges {
  competitionResults: CompetitionResultDto;
  driverWigService: IDriverWigService;
  @Input() fleet: string;
  isTieVisible: boolean;
  @Input() weekStartDate?: Date;

  constructor(private serviceFactory: ServiceFactory) {
    this.driverWigService = serviceFactory.getDriverWigService();
  }

  ngOnChanges() {
    this.loadCompetitionResults();
  }

  private loadCompetitionResults() {
    if (!this.fleet || this.fleet.trim() === '') {
      this.competitionResults = null;
      return;
    }

    this.driverWigService
      .getFleetCompetitionResults(this.fleet, this.weekStartDate)
      .then((data) => {
        this.competitionResults = data;
        if (data) {
          this.isTieVisible = this.competitionResults.tie > 0;
        }
      });
  }
}
